import React, { useEffect, useRef, useState } from 'react'
import TableFilters from '../../../../Components/common/TableGrid/TableFilters'
import { Button, Form, Row, Col, Table, Accordion } from 'react-bootstrap'
import { CallApi, CommonModal, getTodayDateTime } from '../../../../Components/common/CommonFunctions'
import sort from '../../../../assets/images/slotplanning/sort.svg'
import user from '../../../../assets/images/slotplanning/user.svg'
import pdf from '../../../../assets/images/slotplanning/pdf.svg'
import { ReactComponent as Editicon } from "../../../../assets/images/icon_svg/pen_w_line.svg";
import { ReactComponent as Closeicon } from "../../../../assets/images/icon_svg/red_cross.svg";
import { toast } from 'react-toastify'
import Select from 'react-select';
import ActivityComments from '../../../../Components/common/ActivityComments'

const Activity = ({ propData, onReload, openModal, onclose, onComment, closeRemarks }) => {

    const isMounted = useRef(false);
    const [createModal, setCreateModal] = useState(false)
    const initFdata = { start_time: getTodayDateTime().split(' ')[1], end_time: getTodayDateTime().split(' ')[1], }
    const [formData, setFormData] = useState(initFdata)
    const [assets, setAssets] = useState([])
    const [groups, setGroups] = useState([])
    const [groupItems, setGroupItems] = useState([])

    const loadAsset = () => {
        CallApi({
            endPoint: 'shift-report/get-assets',
            method: 'GET',
            onSuccess: (res) => {
                setAssets(res.data.response_data)
            },
            onError: (msg) => toast.error(msg)
        });
    }
    const loadGroup = () => {
        CallApi({
            endPoint: 'shift-report/get-groups',
            method: 'GET',
            onSuccess: (res) => {
                setGroups(res.data.response_data)
                const transData = res.data.response_data?.map(item => ({ label: item.title, value: item.id }))
                setGroupItems(transData)
            },
            onError: (msg) => toast.error(msg)
        });
    }

    useEffect(() => {
        if (isMounted.current) return;
        loadAsset();
        loadGroup();
        isMounted.current = true;
    }, []);

    useEffect(() => { if (openModal) setCreateModal(true) }, [openModal])

    const modalClose = () => {
        setCreateModal(false)
        setFormData(initFdata)
        onclose()
    }
    const EditActivity = (data) => {
        const { id, org_id, shift_report_group_id, title, start_time, end_time, details, action_taken, group } = data;
        setFormData({ id, org_id, group_id: shift_report_group_id, title: title ?? '', start_time, end_time, details, action_taken })
        setCreateModal(true)
    }
    const HandleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }))
    }
    const handleSave = () => {
        CallApi({
            endPoint: 'shift-report/save-activity',
            payload: { ...formData, record_id: propData.id },
            onSuccess: (res) => {

                if (res.data.response_code === 200) {
                    toast.success(res.data.response_msg)
                    // refetch()
                    onReload()
                    modalClose()
                } else {
                    toast.error(res.data.response_msg)
                }
            },
            onError: (msg) => toast.error(msg)
        });
    }

    const assetChange = (chk, id) => {
        // const chkStatus = propData?.assets?.find(i => i.asset_id === id)
        // console.log('chkStatus',chkStatus);
        let payload;
        if (chk) {
            const prevIds = propData.assets.map(i => i.asset_id)
            payload = [...prevIds, id]
        } else {
            payload = propData.assets.filter(i => i.asset_id !== id).map(t => t.asset_id)
        }
        console.log('payload', payload);
        CallApi({
            endPoint: 'shift-report/save-report-asset',
            payload: { id: propData.id, asset_ids: payload },
            onSuccess: (res) => {

                if (res.data.response_code === 200) {
                    toast.success(res.data.response_msg)
                    // refetch()
                    onReload()
                } else {
                    toast.error(res.data.response_msg)
                }
            },
            onError: (msg) => toast.error(msg)
        });
    }

    const [activeKeys, setActiveKeys] = useState([]);

    useEffect(() => {
        if (propData?.grouped_activities) {
            const keys = propData.grouped_activities.map((_, index) => index.toString());
            setActiveKeys(keys);
        }
    }, [propData]);

    const handleToggle = (key) => {
        setActiveKeys((prevKeys) => {
            if (prevKeys.includes(key)) {
                // collapse
                return prevKeys.filter(k => k !== key);
            } else {
                // expand
                return [...prevKeys, key];
            }
        });
    };

    return (
        <>
            <div className="main-wrapper">
                {/* lft sctn */}
                <div className={`${!onComment ? 'w-100' : ''} left_section`}>
                    {/* asset */}
                    <div className="assets-section">
                        <h6>ASSETS ({propData?.assets?.length})</h6>
                        {assets.map((item, i) => (
                            <div key={i} className="asset-row">
                                <span>{item.title}</span>
                                <label className="custom-switch">
                                    <input
                                        type="checkbox"
                                        checked={propData?.assets?.find(i => i.asset_id === item.id) || false}
                                        onChange={(e) => assetChange(e.target.checked, item.id)}
                                    />
                                    <span className="slider"></span>
                                </label>
                            </div>
                        ))}
                    </div>

                    {/* table */}
                    <div className="table-section">

                        {/* HEADER */}
                        <div className="table-header">
                            <div className='tw-15'>Group ({propData?.group_count}) </div>
                            <div className='tw-10'>Start Time</div>
                            <div className='tw-10'>End Time</div>
                            {/* <div>Door</div> */}
                            <div className='tw-30'>Details ({propData?.details_count})</div>
                            <div className='tw-30'>Action Taken ({propData?.action_taken_count})</div>
                            <div className='tw-5'></div>
                        </div>

                        <Accordion alwaysOpen activeKey={activeKeys}>

                            {/* GROUP */}
                            {propData?.grouped_activities?.map((grp, index) => (
                                <Accordion.Item eventKey={index.toString()}>
                                    <Accordion.Header onClick={() => handleToggle(index.toString())}>{grp.title}</Accordion.Header>

                                    <Accordion.Body className="p-0">
                                        {grp?.activities?.length ? grp?.activities?.map((act, i) => (
                                            <>
                                                {/* <div className="sub-row">
                                                    <span>take(1)</span>
                                                </div> */}
                                                <div className="table-row">
                                                    <div className='tw-15'>{act?.title}</div>
                                                    <div className='tw-10'>{act?.start_time.substring(0, 5)}</div>
                                                    <div className='tw-10'>{act?.end_time.substring(0, 5)}</div>
                                                    {/* <div className='tw-10'>1</div> */}
                                                    <div className='tw-30'>{act?.details}</div>
                                                    <div className='tw-30'>{act?.action_taken}</div>
                                                    <div className='tw-5'> <Editicon className='click' onClick={() => EditActivity(act)} /> </div>
                                                </div>
                                            </>
                                        )) :
                                            <></>
                                        }
                                    </Accordion.Body>
                                </Accordion.Item>
                            ))}
                            {/* <Accordion.Item eventKey="0">
                                <Accordion.Header>Access Control</Accordion.Header>

                                <Accordion.Body className="p-0">

                                    <div className="sub-row">
                                        <span>take(1)</span>
                                    </div>
                                    <div className="table-row">
                                        <div></div>
                                        <div>22:00</div>
                                        <div>06:00</div>
                                        <div>Access Control</div>
                                        <div>Take</div>
                                    </div>

                                </Accordion.Body>
                            </Accordion.Item> */}

                            {/* GROUP 2 */}
                            {/* <Accordion.Item eventKey="1">
                                <Accordion.Header>Guidance</Accordion.Header>

                                <Accordion.Body className="p-0">
                                    <div className="sub-row">
                                        <span>take(1)</span>
                                    </div>

                                    <div className="table-row">
                                        <div></div>
                                        <div>22:00</div>
                                        <div>06:00</div>
                                        <div>Access Control</div>
                                        <div>Take</div>
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item> */}

                            {/* GROUP 3 */}
                            {/* <Accordion.Item eventKey="2">
                                <Accordion.Header>Landslide</Accordion.Header>

                                <Accordion.Body className="p-0">
                                    <div className="sub-row">
                                        <span>take(1)</span>
                                    </div>

                                    <div className="table-row">
                                        <div></div>
                                        <div>22:00</div>
                                        <div>06:00</div>
                                        <div>Access Control</div>
                                        <div>Take</div>
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item> */}

                        </Accordion>
                    </div>

                </div>

                {onComment &&
                    <div className="right-section">
                        <div className='custom_close'> <Closeicon width={18} height={18} onClick={closeRemarks} /> </div>
                        <ActivityComments
                            commentable_type={"shift_report"}
                            commentable_id={propData.id}
                            allactivities={propData}
                            onReloadDetails={() => onReload()}
                            noHeader={true}
                        />
                    </div>
                }
                {/*                     
                    <Form.Control
                        as="textarea"
                        rows={2}
                        placeholder="Add comment..."
                        className="comment-box"
                    />

                    <div className="text-end mt-1">
                        <Button size="sm">Submit</Button>
                    </div>

                    <div className="remarks-header">
                        <span>
                            Remarks <span className="badge">20</span>
                        </span>
                        <span><img src={sort} alt='sort' /><span className='remarks_txt'>Most recent</span></span>
                    </div>

                    <div className='remarks_item_wrap'>
                        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (

                            <div key={i} className="remark-item">
                                <div className='d-flex align-items-center'>
                                    <img src={user} alt='user' />
                                    <p className='mb-0'>User {i}</p>
                                    <span>2 min ago</span>
                                </div>
                                <div className="remark-text">
                                    <p>Lorem ipsum dolor sit amet consectetur. Ultricies mi aliquet pellentesque volutpat enim egestas et magna nunc. Commodo duis egestas.</p>
                                </div>
                                <div className="file-tag">
                                    <img src={pdf} alt='pdf' /> Missing report.pdf
                                </div>
                            </div>
                        ))}
                    </div> */}
            </div >
            <CommonModal
                show={createModal}
                onHide={modalClose}
                title='Add Activity'
                subTitle='Create a new activity record.'
                className='addfrom primary_modal'
                footer={
                    <div className='d-flex'>
                        <Button variant="secondary" onClick={modalClose}> Cancel </Button>
                        <Button variant="primary" onClick={handleSave} className="ms-auto"> Create </Button>
                    </div>
                }>
                <Form.Group className='mb-2'>
                    <Form.Label>Select Group</Form.Label>
                    <Select
                        options={groupItems}
                        onChange={selected =>
                            setFormData(prev => ({
                                ...prev,
                                group_id: selected.value
                            }))
                        }
                        placeholder="Select Group"
                        className="down_selct"
                        name="group_id"
                        value={groupItems?.find(option => option.value === formData.group_id) || null}
                    />
                </Form.Group>
                <Form.Group className='mb-2'>
                    <Form.Label>Activity Title</Form.Label>
                    <Form.Control
                        type='text'
                        placeholder="Title"
                        name="title"
                        value={formData.title}
                        onChange={HandleChange}
                    />
                </Form.Group>
                <div className='d-flex justify-content-between'>
                    <Form.Group className='mb-2 tw-45'>
                        <Form.Label>Start Time</Form.Label>
                        <Form.Control
                            type='time'
                            placeholder="Start Time"
                            name="start_time"
                            value={formData.start_time}
                            onChange={HandleChange}
                        />
                    </Form.Group>
                    <Form.Group className='mb-2 tw-45'>
                        <Form.Label>End Time</Form.Label>
                        <Form.Control
                            type='time'
                            placeholder="End Time"
                            name="end_time"
                            value={formData.end_time}
                            onChange={HandleChange}
                        />
                    </Form.Group>
                </div>
                {/* <Form.Group className='mb-2'>
                    <Form.Label>Door</Form.Label>
                    <Form.Control
                        type='time'
                        placeholder="Door no."
                        name="door"
                        value={formData.door}
                        onChange={HandleChange}
                    />
                </Form.Group> */}
                <Form.Group className="mb-2">
                    <Form.Label>Details</Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={12}
                        placeholder="Details"
                        name="details"
                        value={formData.details}
                        onChange={HandleChange}
                        className="custom-textarea"
                    />
                </Form.Group>
                <Form.Group className="mb-2">
                    <Form.Label>Action Taken</Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={12}
                        placeholder="Taken"
                        name="action_taken"
                        value={formData.action_taken}
                        onChange={HandleChange}
                        className="custom-textarea"
                    />
                </Form.Group>
            </CommonModal>
        </>
    )
}

export default Activity